import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { AppConstant } from 'src/app/constants/app.constant';
import { AuthService } from 'src/app/core/services/auth.service';
import { DetailedOrderItem } from 'src/app/models/virtual-store/detailed-order-item.model';
import { OrderItemUpdateRequest } from 'src/app/models/virtual-store/order-item-update-request.model';
import { Service } from 'src/app/models/virtual-store/service.model';
import { OrderItemService } from 'src/app/services/order-item.service';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-popup-cart',
  templateUrl: './popup-cart.component.html',
  styleUrls: ['./popup-cart.component.scss']
})
export class PopupCartComponent implements OnInit {

  clientCode: string;
  orderItemList: DetailedOrderItem[] = [];
  selectedMonthlyPaymentMode: number = 0;
  selectedMonthlyPaymentModeList: number[] = [];
  codeFilterFnb:string=AppConstant.FNB; 
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private router: Router,
  public dialogRef: MatDialogRef<any>,
  private virtualStoreService: VirtualStoreService,
  private orderItemService: OrderItemService,
  private autService:AuthService
  ) { }

  ngOnInit() {
    this.clientCode = this.data.clientCode;
    const elementos = this.data.orderItemList as DetailedOrderItem[];

    const elementosGasodomesticos = elementos.filter( x => x.product.category.description !== 'Servicios');
    let elementosServicios = elementos.filter( x => x.product.category.description === 'Servicios');

    elementosGasodomesticos.forEach(orders => {

      orders.product.serviceList.forEach(service => {
        const regService = elementosServicios.filter( y => y.product.id === service.serviceId);

        if(regService.length > 0)
        {
          service.name = regService[0].product.description;
          service.regularPrice = regService[0].product.price;
          service.discountOfv = regService[0].product.ofvDiscount;
          service.monthlyPaymentCount = regService[0].monthlyPaymentCount;
          service.monthlyPaymentModeList = regService[0].product.monthlyPaymentModeList;
          service.visible = true;
          elementosServicios = elementosServicios.filter( y => y.product.id !== service.serviceId);
        }
      });

      orders.product.serviceList = orders.product.serviceList.filter(x=>x.visible);
      
    });

    this.orderItemList = elementosGasodomesticos;

    this.updateMonthlyPaymentModeList();
  }

  updateMonthlyPaymentModeList() {
    const list = this.orderItemList.map(item => item.product.monthlyPaymentModeList.map(mode => mode.monthCount));
    if (list.length == 1) {
      this.selectedMonthlyPaymentModeList = list[0];
    } else if (list.length > 0) {
      for (let i = 0; i < list.length - 1; i++) {
        list[i + 1] = list[i].filter(x => list[i + 1].some(y => y === x));
        if (i === list.length - 2) {
          this.selectedMonthlyPaymentModeList = list[i + 1];
        }
      }
    }
    this.selectedMonthlyPaymentMode = this.orderItemList.length > 0 ? this.orderItemList[0].monthlyPaymentCount : this.selectedMonthlyPaymentModeList[0];
  }

  getMainImage(orderItem: DetailedOrderItem) {
    
    if (orderItem.product == null) return null;
    if (orderItem.product.imageList && orderItem.product.imageList.filter(x => x.isMain).length > 0) {
      return orderItem.product.imageList.find(x => x.isMain).source;
    } else { return null; }
  }

  getMonthlyPaymentAmount(orderItem: DetailedOrderItem, monthCount: number) {
    const monthlyPaymentMode = orderItem.product.monthlyPaymentModeList.find(x => x.monthCount === monthCount);
    if (monthlyPaymentMode) { return monthlyPaymentMode.amountPerMonth * orderItem.count; } else { return 0; }
  }

  getMonthlyPaymentAmountService(service: Service, monthCount: number) {
    const monthlyPaymentMode = service.monthlyPaymentModeList.find(x => x.monthCount === monthCount);
    if (monthlyPaymentMode) { return monthlyPaymentMode.amountPerMonth * 1; } else { return 0; }
  }

  continue()
  {
    this.dialogRef.close();
    this.router.navigate(['ofivirtual/tienda/mi-carrito']);
  }

  add()
  {
    this.dialogRef.close();
    this.router.navigate(['ofivirtual/tienda']);
  }

  filterUser(user: Service) {
    return user.visible === true;
  }

  itemCountChanged($event: any, product: DetailedOrderItem) {
    let basicData=this.autService.getBasicData();
    const basicItem = new OrderItemUpdateRequest();
    basicItem.id = product.id;
    basicItem.clientCode = this.clientCode;
    basicItem.count = product.count;
    basicItem.monthlyPaymentCount = this.orderItemList[0].monthlyPaymentCount;
    basicItem.documentNumber=basicData.documentNumber;
    basicItem.documentType=basicData.documentType;
    basicItem.isFnb=this.autService.getCreditLineFNB().isCreditLineFNB; 
    this.orderItemService.updatePendingOne(basicItem).subscribe(response => {
      if (response.valid) {
        this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
        this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
      } else if (!response.valid && response.warning) {
        product.count = $event.previousValue;
        Swal.fire('Información', response.message, 'warning')
        this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
        this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
      } else {
        product.count = $event.previousValue;
      }
    })
  }

}
